var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1176 27.7439L31.6235 19.5723C30.9872 18.0764 30.0383 17.2279 28.9554 17.1721C27.8837 17.1163 26.8455 17.8643 26.0529 19.2932L23.9319 23.0999C23.4853 23.9037 22.849 24.3837 22.1569 24.4396C21.4536 24.5065 20.7503 24.1382 20.181 23.4125L19.9354 23.0999C19.1428 22.1064 18.1604 21.6264 17.1557 21.7268C16.151 21.8273 15.2914 22.5195 14.722 23.647L12.7908 27.4984C12.0986 28.8938 12.1656 30.5125 12.9805 31.8298C13.7955 33.1471 15.2132 33.9397 16.765 33.9397H31.0095C32.5054 33.9397 33.9008 33.1917 34.7269 31.9414C35.5753 30.6911 35.7093 29.1171 35.1176 27.7439Z",
    fill: "#39D3B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3152 18.3223C20.3992 18.3223 22.0884 16.633 22.0884 14.5491C22.0884 12.4652 20.3992 10.7758 18.3152 10.7758C16.2313 10.7758 14.542 12.4652 14.542 14.5491C14.542 16.633 16.2313 18.3223 18.3152 18.3223Z",
    fill: "#39D3B1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8428 3L39.8428 16.0107",
    stroke: "#FBD178",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3486 9.50531L33.3379 9.50531",
    stroke: "#FBD178",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2563 4.84698H17C9.26801 4.84698 3 11.115 3 18.847V26.42C3 34.152 9.26801 40.42 17 40.42H30.5019C38.2338 40.42 44.5019 34.152 44.5019 26.42V23.0926",
    stroke: "#39D3B1",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetImage);
export default __webpack_public_path__ + "static/media/WIDGET_IMAGE.eb4d16589e1aff3fe11b226bfbcfdbf0.svg";
export { ForwardRef as ReactComponent };